<div class="layout-container" [ngClass]="containerClass">
  <app-topbar />
  <app-sign-in-as-refusal />
  <app-sidebar />
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <!-- The breadcrumb sits OUTSIDE the scroll area so it stays frozen while the page scrolls
           (mirrors US #1354). Scrolling content is clipped by the scroll div below — it can never
           reach this strip, so no sticky/z-index/background is needed. -->
      <app-breadcrumb />
      <!-- The scroller. It keeps the `layout-content-router-outlet` id because that id is how pages
           (load list, vouchers, QuoteLoadBridge) grab their scroll container. -->
      <div id="layout-content-router-outlet" class="layout-content-scroll" #contentScroll>
        <!-- Flex column so the footer's mt-auto actually reaches the bottom of the scroll area
             instead of sitting directly under short page content. -->
        <!-- `relative` makes this column the containing block for the pages' floating action clusters.
             Without it they resolve against the scroll box — its bottom edge and the footer's position
             differ by however much the page overflows, so the Save button drifted off the footer line
             on any page tall enough to scroll. -->
        <div class="flex flex-col min-h-full relative">
          <router-outlet />
          <!-- layout-footer-band: on desktop the footer lines up with the menu's foot (premium-shell.css). -->
          <div class="layout-footer-band py-4 mt-auto">
            <app-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
  <global-common-progressspinner />
</div>
